import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { ModalHeaderProps } from './ModalHeader.types';
import PressableIcon from '../../PressableIcon/PressableIcon';
import Box from '../../Box/Box';
import Text from '../../Text/Text';

function ModalHeader({
  title,
  titleNS,
  titleKey,
  canClose,
  close,
}: ModalHeaderProps) {
  const [t] = useTranslation(titleNS);

  return (
    <Box padding="space-400" centerContent>
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        position="absolute"
        numberOfLines={1}
      >
        {titleNS && titleKey ? t(titleKey) : title}
      </Text>
      {canClose ? (
        <PressableIcon
          name="close"
          width="space-600"
          height="space-600"
          color="iconSecondary"
          alignSelf="flex-end"
          onPress={close}
        />
      ) : null}
    </Box>
  );
}

export default memo(ModalHeader);
